import React from "react";
import Tooltip from '@material-ui/core/Tooltip';
import {useHistory} from "react-router-dom";
import {ErrorPage} from "../../shared/ErrorPage";
import LoadingIcon from "../../shared/LoadingIcon";
import {ROUTES} from "../../utils/RouteConstants";
import DependantsTable from "./DependantsTable";
import {formatDate} from "../../utils/Utils";
import {ROLES} from "../../api/Constants";
import {useFetchDependants} from "./hooks";
import FetchState from "../../api/FetchState";
import useUserData from "../../hooks/useUserData";
import {ClickableName} from "../../styles/globalStyles"

export default function DependantsScreen() {

  const user = useUserData();
  let history = useHistory();

  const tableHeaders = {
    columns: [
      { title: "Name", field: "name" },
      { title: "Surname", field: "surname" },
      { title: "Member",
        render: (rowData) => <> { user != null &&
              user.role.id <= ROLES.ADMIN ?
                <Tooltip title="Click to Edit Member">
                  <ClickableName
                    onClick={() =>
                      history.push(ROUTES.MEMBERS_FORM, {
                        last: ROUTES.DEPENDANTS,
                        member: rowData.member,
                        edit: true,
                      })
                    }
                  >
                    {rowData.member.fullName}
                  </ClickableName>
                </Tooltip>
              :
              rowData.member.fullName
        }</>,},
      { title: "Relationship", field: "relationship.name" },
      { title: "Claimed", field: "claimed", type: "boolean" },
      { title: "ID Number", field: "idNumber" },
      {
        title: "DOE",
        render: (rowData) => <div>{formatDate(rowData.doe)}</div>,
      },
    ],
  };

  const [data, fetchState] = useFetchDependants();

  if (FetchState.SUCCESS === fetchState)
    return (<>

          <br/><br/>

          <DependantsTable
              last = {ROUTES.DEPENDANTS}
              showDropDown
              tableData = {data}
              tableHeaders = {tableHeaders}
          />
    </>)
  else if (FetchState.ERROR === fetchState) return <ErrorPage />
  else if (FetchState.LOADING === fetchState) return <LoadingIcon />

}
